import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://550dbdca5bbb4e792507916ea9a9289e@o4507261959012352.ingest.us.sentry.io/4507261960388608',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
